export default "<div *ngIf=\"messages.length > 0\">\n    <ul *ngFor=\"let message of messages\">\n        <li> {{message}}</li>\n    </ul>\n</div>"